export default __webpack_public_path__ + "static/media/logoInvoice.6ececfa3.png";